export function getRequesterIds(store, query) {
    const subs = store.getConnectionsForQuery(query);
    return subs.reduce((acc, sub) => {
        var _a;
        if ((_a = sub.meta) === null || _a === void 0 ? void 0 : _a.requesterId) {
            acc.push(sub.meta.requesterId);
        }
        return acc;
    }, []).join(",");
}
//# sourceMappingURL=GetRequesterIds.js.map